/**
 * @description 菜单下拉
 * @type {menuDropdown}
 */
const menuDropdown = class extends HTMLElement {
  constructor() {
    super();
    // 处理子元素
    const dropdownMenu = this.querySelectorAll("li");
    const dropdownContent = this.querySelectorAll(".right-content .item");
    let activeIndex = 0;
    dropdownMenu.forEach((item, index) => {
      item.addEventListener("mouseover", () => {
        if (index < dropdownContent.length) {
          // 处理li
          dropdownMenu[activeIndex].classList.remove("active");
          item.classList.add("active");
          dropdownContent[activeIndex].classList.remove("active");
          dropdownContent[index].classList.add("active");
          activeIndex = index;
        }
      });
    });

    //监听父元素变化
    const parentNode = this.parentNode;
    parentNode.addEventListener("mouseleave", () => {
      if (dropdownMenu[activeIndex]) {
        dropdownMenu[activeIndex].classList.remove("active");
      }
      if (dropdownContent[activeIndex]) {
        dropdownContent[activeIndex].classList.remove("active");
      }
      if (dropdownMenu[0]) {
        dropdownMenu[0].classList.add("active");
      }
      if (dropdownContent[0]) {
        dropdownContent[0].classList.add("active");
      }
      activeIndex = 0;
      document.body.style.overflow = "";
      // 恢复body滚动
      document.body.classList.remove("no-scroll");
      document.documentElement.style.setProperty("--scrollbar-width", "17px");
    });

    // 获得焦点禁止body滚动
    parentNode.addEventListener("mouseover", () => {
      const scrollbarWidth = this.getScrollbarWidth();

      document.documentElement.style.setProperty(
        "--scrollbar-width",
        scrollbarWidth + "px"
      );
      document.body.classList.add("no-scroll");

      this.style.top =
        parentNode.offsetTop +
        parentNode.offsetHeight -
        document.documentElement.scrollTop -
        1 +
        "px";
    });

    // 鼠标失去焦点事件  需要的时候开启
    const mask = this.querySelector(".mask");
    mask.addEventListener("mouseover", () => {
      parentNode.style.pointerEvents = "none";
    });
    mask.addEventListener("mouseout", () => {
      setTimeout(() => {
        parentNode.style.pointerEvents = "auto";
      }, 300);
    });
  }

  /**
   * 获取滚动条宽度
   * @returns {number}
   */
  getScrollbarWidth() {
    const container = document.createElement("div");
    document.body.appendChild(container);
    container.style.overflow = "scroll";
    const inner = document.createElement("div");
    container.appendChild(inner);
    const scrollbarWidth = container.offsetWidth - inner.offsetWidth;
    document.body.removeChild(container);
    return scrollbarWidth;
  }
};
if (!window.customElements.get("menu-dropdown")) {
  window.customElements.define("menu-dropdown", menuDropdown);
}

// 监听菜单栏展开与关闭的操作
window.addEventListener("header-toggle", (e) => {
  const modelMenuBox = document.querySelector(".model-menu");
  if (e.detail.open) {
    document.body.classList.add("no-scroll");
    modelMenuBox.classList.add("active");
    modelMenuBox.style.height =
      "calc(100vh - " +
      (modelMenuBox.parentNode.offsetTop +
        modelMenuBox.parentNode.offsetHeight -
        document.documentElement.scrollTop) +
      "px)";
    modelMenuBox.style.top =
      modelMenuBox.parentNode.offsetTop +
      modelMenuBox.parentNode.offsetHeight -
      document.documentElement.scrollTop +
      "px";
  } else {
    document.body.classList.remove("no-scroll");
    modelMenuBox.classList.remove("active");
    modelMenuBox.style.top = -100 + "px";
  }
});

/**
 * 防抖函数
 * @param func
 * @param wait
 * @returns {(function(): void)|*}
 * @private
 */
function _debounce(func, wait) {
  let timeout;
  return function () {
    clearTimeout(timeout);
    timeout = setTimeout(func, wait);
  };
}

/**
 * 重置手风琴
 */
function resetAccordion() {
  const accordionAll = document.querySelectorAll(
    ".model-menu .accordion.group"
  );
  accordionAll.forEach((item) => {
    item.open = false;
  });
}

/**
 * 处理移动端菜单栏展开与关闭事件
 * @type {Element}
 */

const modelMenuOpenEl = document.querySelector(
  ".components-header .header-toggle .open"
);
const modelMenuCloseEl = document.querySelector(
  ".components-header .header-toggle .close"
);
modelMenuOpenEl.addEventListener("click", () => {
  modelMenuOpenEl.classList.remove("active");
  modelMenuCloseEl.classList.add("active");
  window.dispatchEvent(
    new CustomEvent("header-toggle", { bubbles: true, detail: { open: true } })
  );
});

modelMenuCloseEl.addEventListener("click", () => {
  modelMenuCloseEl.classList.remove("active");
  modelMenuOpenEl.classList.add("active");
  window.dispatchEvent(
    new CustomEvent("header-toggle", { bubbles: true, detail: { open: false } })
  );
  this.resetAccordion();
});

/**
 * 窗口大小变化时，判断是否需要关闭窗口
 */
function updateSizeDisplay() {
  const width = window.innerWidth;
  if (width >= 1200) {
    if (modelMenuCloseEl.classList.contains("active")) {
      modelMenuCloseEl.classList.remove("active");
      modelMenuOpenEl.classList.add("active");
      window.dispatchEvent(
        new CustomEvent("header-toggle", {
          bubbles: true,
          detail: { open: false },
        })
      );
    }
  }
}

//处理窗口大小变化的问题
window.addEventListener("resize", _debounce(updateSizeDisplay, 100));

window.addEventListener("DOMContentLoaded", () => {
  // 监听手风琴的展开与关闭事件,只允许展开一个
  const accordionAll = document.querySelectorAll(
    ".model-menu .accordion__content .accordion.group"
  );
  accordionAll.forEach((item) => {
    item.addEventListener("toggle", () => {
      if (item.open) {
        accordionAll.forEach((subItem) => {
          if (subItem !== item) {
            subItem.open = false;
          }
        });
      }
    });
  });
});

window.addEventListener("DOMContentLoaded", () => {
  const headerProductImageContainer = document.querySelectorAll(
    ".components-header .menu-dropdown-content .product-item .image"
  );
  headerProductImageContainer.forEach((item) => {
    const magnifier = item.querySelector(".magnifier");
    if (magnifier) {
      item.addEventListener("mousemove", () => {
        magnifier.classList.add("show");
      });

      item.addEventListener("mouseleave", () => {
        magnifier.classList.remove("show");
      });
    }
  });
});

window.customElements.get("menu-dropdown-link") ||
  window.customElements.define(
    "menu-dropdown-link",
    class extends HTMLElement {
      constructor() {
        super();
        const parentNode = this.parentNode;
        parentNode.addEventListener("mouseover", () => {
          const rect = parentNode.getBoundingClientRect();
          parentNode.style.setProperty("--top", `${rect.bottom}px`);
          parentNode.style.setProperty("--left", `${rect.left}px`);
        });
      }
    }
  );


// 站点选择显示关闭
window.addEventListener("DOMContentLoaded", () => {
  const marketDrawer = document.querySelector(
    "we-drawer#navigation-market-drawer",
  );
  const marketBtn = document.querySelector("#navigation-market-btn");
  const marketMobBtn = document.querySelector(
    "#navigation-market-mob-btn",
  );

  if (marketBtn && marketDrawer) marketBtn.addEventListener("click", () => marketDrawer.open());
  if (marketMobBtn && marketDrawer) marketMobBtn.addEventListener("click", () => marketDrawer.open());
});